export const environment = {
  production: true,
  ImpataAppAPIRoot: "https://preprodlms.impata.com/",

  //ImpataAppAPIRoot : "https://localhost:44326/",

  userTokenStore: "utkn",
  timezoneapikey: "0d933aa277de4030ae2203539fdf47c4",
  schConfig: "schcfg",
  googleClientId: "781136971353-sq8njd14nkgom1c7jctt9jfioo10a6t0.apps.googleusercontent.com",
  ImpataAppDomainUrl: "https://preprod.impata.com"
};
